/* eslint-disable no-unused-vars */
import DistributorService from '_services/rest/modules/distributor';

export default {
  state: {
    distributor: null,
    distributorList: null,
    detachedRegions: null,
    attachedRegions: null,
    allAttachedRegions: null,
  },
  mutations: {
    setDistributorList(state, response) {
      state.distributorList = response;
    },
    setDistributor(state, response) {
      state.distributor = response;
    },
    setDetachedRegions(state, response) {
      state.detachedRegions = response;
    },
    setAttachedRegions(state, response) {
      state.attachedRegions = response;
    },
    setAllAttachedRegions(state, response) {
      state.allAttachedRegions = response;
    },
  },
  actions: {
    getDistributorList({ commit }, params) {
      return DistributorService.getList(params).then(response => {
        commit('setDistributorList', response);
      });
    },
    getDistributor({ commit }, params) {
      return DistributorService.getDistributorById(params)
        .then(distributor => {
          commit('setDistributor', distributor);
          return distributor;
        })
        .catch(error => {
          throw error.message;
        });
    },
    deleteDistributor({ commit }, params) {
      return DistributorService.delete(params);
    },
    getDistributorRegions({ commit }, params) {
      if (!params.search && params.group === 'attached') {
        return DistributorService.getDistributorRegions({
          ...params,
          take: 0,
        }).then(response => {
          if (params.page === 1) commit('setAllAttachedRegions', response);
          commit('setAttachedRegions', response);
          return response;
        });
      }

      return DistributorService.getDistributorRegions(params).then(response => {
        if (params.group && params.group === 'attached') {
          if (!params.search) {
            commit('setAllAttachedRegions', response);
          }
          commit('setAttachedRegions', response);
          return response;
        }
        commit('setDetachedRegions', response);
        return response;
      });
    },
    syncRegions({ commit }, { attachedRegions, id }) {
      const regions = attachedRegions.map(region => ({
        id: region.id,
      }));
      commit('setAllAttachedRegions', {
        total_items: attachedRegions.length,
        pages: Math.ceil(attachedRegions.length / 10),
        list: attachedRegions
      });
      return DistributorService.syncRegions({
        id,
        regions,
      });
    },
    saveStates({ commit }, { states, id }) {
      return DistributorService.saveStates({
        id,
        states,
      });
    },
  },
};
